// extracted by mini-css-extract-plugin
export default {"wrapper":"AddGateway_wrapper__3exZN","tips":"AddGateway_tips__xs3Ed","blue":"AddGateway_blue__nuUA1","info":"AddGateway_info__n7Vz8"};